import React, { createContext, useState, useContext } from "react";

const CustomerCodeContext = createContext();

export const CustomerCodeProvider = ({ children }) => {
  const [selectedCustomerCode, setSelectedCustomerCode] = useState("");
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [customerData, setCustomerData] = useState(null);

  return (
    <CustomerCodeContext.Provider
      value={{
        selectedCustomerCode,
        setSelectedCustomerCode,
        selectedCustomerName,
        setSelectedCustomerName,
        customerData,
        setCustomerData,
      }}
    >
      {children}
    </CustomerCodeContext.Provider>
  );
};

export const useCustomerCode = () => useContext(CustomerCodeContext);
